export type MerchKey = 'black_shirt_men' | 'cream_shirt_men' | 'white_shirt_girls' | string;

export interface MerchItemDef {
  key: string;
  name: string;
  shortName: string;
  subtitle: string;
  category: 'men' | 'women' | 'unisex';
  color: 'black' | 'cream' | 'white';
  imageUri: string;
  description: string;
}

export const MERCH_CATALOG: Record<string, MerchItemDef> = {
  black_shirt_men: {
    key: 'black_shirt_men',
    name: 'Black Clero Tee (Men)',
    shortName: 'Black Tee',
    subtitle: 'Official Merch · Men’s Fit',
    category: 'men',
    color: 'black',
    imageUri: '/merch/black_shirt_men.png',
    description: 'Vintage black wash tee with "spotting fees apply. Clero me." back print',
  },
  cream_shirt_men: {
    key: 'cream_shirt_men',
    name: 'Cream Clero Tee (Men)',
    shortName: 'Cream Tee',
    subtitle: 'Official Merch · Men’s Fit',
    category: 'men',
    color: 'cream',
    imageUri: '/merch/cream_shirt_men.png',
    description: 'Vintage cream wash tee with "JUST Clero ME." back print',
  },
  white_shirt_girls: {
    key: 'white_shirt_girls',
    name: 'White Clero Crop Tee (Girls)',
    shortName: 'White Crop Tee',
    subtitle: 'Official Merch · Women’s Fit',
    category: 'women',
    color: 'white',
    imageUri: '/merch/white_shirt_girls.png',
    description: 'White cropped baby tee with "JUST Clero ME." print',
  },
};

export const DEFAULT_MERCH_KEY: MerchKey = 'black_shirt_men';

export function resolveMerchMeta(rawType?: string | null): MerchItemDef {
  const clean = String(rawType || '').trim().toLowerCase();
  if (clean && MERCH_CATALOG[clean]) {
    return MERCH_CATALOG[clean];
  }
  // Common aliases / legacy values
  if (clean === 'cream' || clean.includes('cream')) {
    return MERCH_CATALOG.cream_shirt_men;
  }
  if (clean === 'white' || clean.includes('girl') || clean.includes('crop') || clean.includes('women')) {
    return MERCH_CATALOG.white_shirt_girls;
  }
  return MERCH_CATALOG.black_shirt_men;
}
